import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import "./DashboardPage.css";
import shopee from "./../../../../assets/user_orders.svg";
import products from "./../../../../assets/user_wishlist.svg";
import income from "./../../../../assets/user_like.svg";
import percent from "./../../../../assets/user_notification.svg";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeletepopupPage from "../../../modal/components/DeletepopupPage";
import NodatafoundPage from "../../../nodatafound/components/NodatafoundPage";
import no_orders from "./../../../../assets/no_orders.svg";
import { fetchUserdashboard } from "../redux/actions";
import { useTranslation } from "react-i18next";
import { newOrdercount } from "../../dashboard/redux/actions";
import { fetchHeaderContent } from "../../../seoroute/redux/actions";
import dots_vertical from "../../../../assets/dots_vertical.svg";
import NotificationPage from "../../../notification/components/NotificationPage";
import { postRequestcall } from "../../../comman/util/postRequest";
import { USER_DASHBOARD, ORDER_STATUS, SEND_ORDERSTATUS } from "../../../constants/apiurl";
import CountboxPage from "../../../comman/components/CountboxPage";
import moment from "moment";

function DashboardPage(props) {
  const { access_token, fetchUserdashboard } = props;
  const { t } = useTranslation();
  const [orderList, setOrderList] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteInfo, setDeleteinfo] = useState({
    title: t("pages.deletepop.deleteorder"),
    sub_title: t("pages.deletepop.sub_title"),
    name: "",
    id: "",
    type: t("pages.deletepop.order"),
    order_status: "",
  });
  const [userDashboard, setUserdashboard] = useState({});
  const [noorder, setNoorder] = useState(false);
  const navigate = useNavigate();
  const orderStatus = [
    {
      orderstatus: "Accepted",
      orderstatus_tr: "Kabul edilmiş",
    },
    {
      orderstatus: "Packed",
      orderstatus_tr: "Paketlenmiş",
    },
    {
      orderstatus: "Dispatched",
      orderstatus_tr: "Sevk edilen",
    },
    {
      orderstatus: "Delivered",
      orderstatus_tr: "Teslim edilmiş",
    },
    {
      orderstatus: "Cancelled",
      orderstatus_tr: "İptal edildi",
    },
  ];
  useEffect(() => {
    setDeleteinfo({
      ...deleteInfo,
      title: t("pages.deletepop.deleteorder"),
      sub_title: t("pages.deletepop.sub_title"),
      name: "",
      id: "",
      type: t("pages.deletepop.order"),
      order_status: "",
    });
    (async () => callUserdashboard())();
    // eslint-disable-next-line
  }, [props?.language]);

  const callUserdashboard = async () => {
    props?.fetchHeaderContent(t("pages.sidenav.dashboard"), "", "");
    let getUserresponse = await postRequestcall(
      USER_DASHBOARD,
      access_token,
      ""
    );
    if (getUserresponse?.status === 200) {
      let res = await getUserresponse.json();
      setUserdashboard(res?.data);
      fetchUserdashboard(res?.data);
      props.newOrdercount(res?.data?.new_orders);
      if (res?.data?.latestOrders?.length === 0) {
        setNoorder(true);
      } else {
        setNoorder(false);
        setOrderList(res?.data?.latestOrders);
      }
    } else if (getUserresponse?.status === 500) {
      toast.error(t("pages.internal"));
    }
  };

  const callCancelOrders = async () => {
    if (
      deleteInfo?.order_status === t("pages.Delivered") ||
      deleteInfo?.order_status === t("pages.Cancelled") ||
      deleteInfo?.order_status === ""
    ) {
      toast(`${t("pages.toast.unable_order")} ${deleteInfo?.order_status}`);
    } else {
      let geturl =
        ORDER_STATUS +
        `?order_status=${t("pages.Cancelled")}&id=${
          deleteInfo.id
        }&lang=${props?.language?.toLowerCase()}`;
      let getChangeorderapiResponce = await postRequestcall(
        geturl,
        access_token,
        ""
      );
      if (getChangeorderapiResponce?.status === 200) {
        orderList.forEach((item) => {
          if (item.id === deleteInfo?.id) {
            item.order_status = "Cancelled";
          }
        });
        setOrderList(orderList);
        let getOrderurl = SEND_ORDERSTATUS + `?order_status=${t("pages.Cancelled")}&id=${deleteInfo.id}&lang=${props?.language?.toLowerCase()}`
        await postRequestcall(getOrderurl,access_token,"");
      }
    }
  };

  const cancelOrder = (e, item) => {
    e.preventDefault();
    setDeleteinfo({
      ...deleteInfo,
      name: item?.display_order_id,
      id: item?.id,
      order_status: item?.order_status,
    });
    setDeleteModal(true);
  };

  return (
    <div className="card user-dashboard border-0 radius-20" id="User">
      <div className="card-body p-0">
        <Row>
          <div className="col-12">
            <Row>
             <CountboxPage className={"col-xl-3 count-box"} cardName={"card my-orders"} navigate={
              "/user/myorders"
             } image={shopee} count={userDashboard?.my_orders} label={t("pages.dashboard.myorders")} />
             <CountboxPage className={"col-xl-3 count-box"} cardName={"card my-wishlist"} navigate={
              "/user/wishlist"
             } image={products} count={userDashboard?.my_wishlists} label={t("pages.dashboard.mywishlist")} />
             <CountboxPage className={"col-xl-3 count-box"} cardName={"card my-reviews"} navigate={
              "/user/review"
             } image={income} count={userDashboard?.my_reviews} label={t("pages.dashboard.myreviews")} />
             <CountboxPage className={"col-xl-3 count-box"} cardName={"card my-notification"} navigate={
              "/user/notifications"
             } image={percent} count={userDashboard?.notifications} label={t("pages.dashboard.notifications")} />
            </Row>
            <Row className="mt-4">
              <div className="dflex justify-between m-al-start align-center">
                <h5>{t("pages.dashboard.lastorders")}</h5>
                <h5
                  className="pr-color text-12 pointer"
                  onClick={() => navigate("/user/myorders")}
                >
                  {t("pages.dashboard.viewall")}
                </h5>
              </div>
              <div className="col-12 desktop_orderlist">
                {noorder ? (
                  <NodatafoundPage
                    className={"user-reviews-centent"}
                    image={no_orders}
                    title={t("pages.myorders.noorder")}
                    description={t("pages.myorders.noorder_description")}
                    navigation={"/user/dashboard"}
                  />
                ) : (
                  orderList?.map((item, index) => (
                    <table
                      id="order_list"
                      key={index.toString()}
                      className="mt-2 hover_shadow"
                    >
                      <tbody className="table_tbody">
                        <tr className="text-14 header_section">
                          <th> {t("pages.myorders.orderplace")}</th>
                          <th>{t("pages.myorders.total")}</th>
                          <th>{t("pages.myorders.delivery_address")}</th>
                          <th>
                            {t("pages.myorders.order")} {item?.display_order_id}
                          </th>
                          <th>{t("pages.myorders.status")} </th>
                          <th
                            className="view_detail"
                            align="center"
                            rowSpan={2}
                          >
                            <button
                              onClick={() =>
                                navigate(`/user/myorders/${item?.id}`)
                              }
                              className="btn-white pr-blue-btn"
                            >
                              {t("pages.myorders.viewdetail")}
                            </button>
                          </th>
                          <th className="menu" rowSpan={2}>
                            <Dropdown
                              className={"order_menu"}
                              id={"order_menu"}
                            >
                              <Dropdown.Toggle
                                variant="success"
                                className="text-20"
                                id="dropdown-basic"
                              >
                                <img
                                  src={dots_vertical}
                                  height="25"
                                  width="25"
                                  alt="option"
                                ></img>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={(e) => cancelOrder(e, item)}
                                  className="pr-color"
                                  href="#/action-2"
                                >
                                  {t("pages.myorders.cancelorder")}
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </th>
                        </tr>
                        <tr className="body_section">
                          <td className="products">
                            <h5 className="mb-0">
                              {moment(item?.created_at).format("MMMM DD, YYYY")}
                            </h5>
                          </td>
                          <td className="qty">
                            {Number(item?.total)?.toFixed(2)}
                            {process.env.REACT_APP_CURRENCY_SYMBOL}
                          </td>
                          <td className="datetime">{item?.address}</td>
                          <td className="amount">
                            {t("pages.myorders.orderdetails")}
                          </td>
                          <td className={`amount status ${item?.order_status}`}>
                            {orderStatus.map((value, index) =>
                              value.orderstatus === item?.order_status ? (
                                props.language === "Tr" ? (
                                  value.orderstatus_tr
                                ) : (
                                  item?.order_status
                                )
                              ) : (
                                <></>
                              )
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ))
                )}
              </div>
            </Row>
            <div className="mt-4">
              <div className="dflex justify-between m-al-start align-center">
                <h5>{t("pages.dashboard.notification")}</h5>
                <h5
                  className="pr-color text-12 pointer"
                  onClick={() => navigate("/user/notifications")}
                >
                  {t("pages.dashboard.viewall")}
                </h5>
              </div>
              <NotificationPage dashboard={true}></NotificationPage>
            </div>
          </div>
        </Row>
      </div>
      <DeletepopupPage
        setDeleteModal={setDeleteModal}
        deleteInfo={deleteInfo}
        deleteModal={deleteModal}
        itemDelete={callCancelOrders}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, {
  fetchUserdashboard,
  newOrdercount,
  fetchHeaderContent,
})(DashboardPage);
